
import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { fadeInUp, sparkleAnimation } from './animations';

export const HeaderTitle: React.FC = () => {
  return (
    <motion.div 
      className="text-center md:text-left w-full" 
      initial="hidden" 
      animate="visible"
    >
      <motion.div 
        className="space-y-1 flex flex-col md:flex-row md:items-center md:space-x-4 md:space-y-0" 
        variants={fadeInUp} 
        custom={0}
      >
        <h1 className="relative flex flex-col md:flex-row md:items-center md:gap-2">
          <span className="text-sm md:text-lg font-bold italic bg-gradient-to-r from-white via-amber-100 to-yellow-200 bg-clip-text text-transparent px-1 drop-shadow-sm leading-tight py-[10px]">
            "Có một Thanh Xuân mang tên
          </span>
          <div className="flex flex-col md:flex-row md:items-end gap-1">
            <motion.span 
              animate={{
                textShadow: ["0 0 5px rgba(255,215,0,0.3)", "0 0 15px rgba(255,215,0,0.5)", "0 0 5px rgba(255,215,0,0.3)"]
              }} 
              transition={{
                duration: 3,
                repeat: Infinity,
                ease: "easeInOut"
              }} 
              className="text-lg md:text-2xl italic bg-gradient-to-r from-yellow-300 via-amber-400 to-yellow-500 bg-clip-text text-transparent drop-shadow-lg leading-tight relative z-10 py-1 px-[6px] font-semibold"
            >
              Lê Hồng Phong"
              <motion.div 
                className="absolute inset-0 -z-10 bg-gradient-to-r from-blue-500/15 via-purple-500/15 to-blue-500/15 blur-md rounded-full" 
                animate={{
                  opacity: [0.5, 0.8, 0.5],
                  scale: [0.98, 1.02, 0.98]
                }} 
                transition={{
                  duration: 2.5,
                  repeat: Infinity,
                  ease: "easeInOut"
                }} 
              />
              <motion.div 
                className="absolute top-0 left-0 right-0 bottom-0 -z-20 rounded-lg opacity-30" 
                animate={{
                  background: ["linear-gradient(90deg, #FFD700 0%, #FF8C00 50%, #FFD700 100%)", "linear-gradient(90deg, #FF8C00 0%, #FFD700 50%, #FF8C00 100%)", "linear-gradient(90deg, #FFD700 0%, #FF8C00 50%, #FFD700 100%)"]
                }} 
                transition={{
                  duration: 3,
                  repeat: Infinity,
                  ease: "easeInOut"
                }} 
              />
              <motion.div 
                className="absolute -left-1 -right-1 -top-1 -bottom-1 -z-30 rounded-lg opacity-20" 
                animate={{
                  boxShadow: ["0 0 8px 2px rgba(255,215,0,0.6)", "0 0 16px 6px rgba(255,140,0,0.7)", "0 0 8px 2px rgba(255,215,0,0.6)"]
                }} 
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  ease: "easeInOut"
                }} 
              />
            </motion.span>
          </div>
          
          <motion.div 
            className="absolute -right-2 -top-2 md:-right-3 md:-top-2" 
            animate={sparkleAnimation}
          >
            <Sparkles className="h-4 w-4 md:h-5 md:w-5 text-yellow-200" />
          </motion.div>
        </h1>
        
        <div className="flex flex-col justify-center md:justify-end mt-2 md:mt-0">
          <motion.div 
            className="bg-gradient-to-r from-amber-300 to-yellow-400 px-3 py-1 rounded-full shadow-md" 
            animate={{
              rotate: [-1, 0.5, -1],
              scale: [1, 1.02, 1]
            }} 
            transition={{
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          >
            <span className="text-sm font-bold text-blue-900 md:text-sm">
              Họp mặt Cựu Học Sinh
            </span>
          </motion.div>
          
          <motion.div 
            initial={{
              opacity: 0,
              y: 10
            }} 
            animate={{
              opacity: 1,
              y: 0
            }} 
            transition={{
              delay: 0.4,
              duration: 0.5
            }} 
            className="px-2 py-0.5 mt-1.5 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20 mx-auto md:mx-0"
          >
            <span className="text-xs md:text-sm font-medium text-sky-100">
              <span className="font-bold text-white text-xs">Niên khoá 2002-2005</span>
            </span>
          </motion.div>
        </div>
      </motion.div>
    </motion.div>
  );
};
